import noUiSlider from "nouislider";

class RangeSlider {
  slider = null;

  constructor(
    params = {
      selector: ".js-range-slider",
      options: {},
      onChange: () => {},
    }
  ) {
    const el = document.querySelector(params.selector);

    if (el) {
      this.slider = noUiSlider.create(el, {
        start: Number(el?.dataset?.start) ?? 0,
         step: 1,
        connect: "lower",
        animate: true,
        orientation: "horizontal",
        behaviour: "tap-drag",
        tooltips: false,
        range: {
          min: 0,
          max: 2,
        },
        ...params.options,
      });

      // (values, handle, unencoded, tap, positions, noUiSlider)
      this.slider.on("change", params.onChange);
    }
  }
}

export default RangeSlider;
